export const LoginHighlights = () => (
  <div className="flex flex-col justify-between space-y-8 text-slate-100">
    <div className="space-y-6">
      <div className="inline-flex items-center gap-3 rounded-full bg-white/10 px-5 py-2 text-xs font-semibold uppercase tracking-[0.4em] text-slate-200">
        <span className="grid h-8 w-8 place-items-center rounded-2xl bg-white/20 text-lg font-semibold">
          A
        </span>
        Allegro Control Center
      </div>
      <div className="space-y-4">
        <h1 className="text-4xl font-semibold tracking-tight md:text-5xl">
          Welcome back to your cockpit
        </h1>
        <p className="text-base text-slate-100 md:text-lg">
          Monitor orders, margins, and billing in one place. Sign in to pick up where you left off
          and keep your operations in rhythm.
        </p>
      </div>
    </div>
    <ul className="grid gap-4 text-sm text-slate-100 md:grid-cols-2">
      <li className="flex items-center gap-2 rounded-2xl bg-white/5 px-4 py-3">
        <span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
        Real-time Allegro sync
      </li>
      <li className="flex items-center gap-2 rounded-2xl bg-white/5 px-4 py-3">
        <span className="h-2.5 w-2.5 rounded-full bg-sky-400" />
        Profitability dashboards
      </li>
      <li className="flex items-center gap-2 rounded-2xl bg-white/5 px-4 py-3">
        <span className="h-2.5 w-2.5 rounded-full bg-violet-400" />
        Automated fee tracking
      </li>
      <li className="flex items-center gap-2 rounded-2xl bg-white/5 px-4 py-3">
        <span className="h-2.5 w-2.5 rounded-full bg-rose-400" />
        Secure account access
      </li>
    </ul>
  </div>
);
